import api from '../api';

/**
 * Deletes a notification.
 *
 * @param {string} title - The title of the notification.
 * @param {Date} date - The date of the notification.
 * @return {Promise<Object>} - The response from the API.
 * @throws {Error} - If the request fails.
 */
const deleteNotification = async (id) => {
  const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/api/notification/delete`;
  try {
    const response = await api.delete(endpoint, {
      params: { id }
    });

    return response.data;
  } catch (error) {
    console.error('Error deleting notification:', error);
    throw error;
  }
}

export default deleteNotification;
